import { uri } from "../constants";

export const getAllArtists = async () => {
  try {
    const response = await fetch(`${uri}/users/artists`);
    if (!response.ok) throw new Error("Failed to fetch artists");
    return await response.json();
  } catch (error) {
    console.error("Error fetching artists:", error);
    throw error;
  }
};

export const getArtists = async (userId) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/artists`);
    if (!response.ok) throw new Error("Failed to fetch user artists");
    let data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching user artists:", error);
    throw error;
  }
};

export const getArtist = async (userId, artistId) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/artists/${artistId}`);
    if (!response.ok) throw new Error("Failed to fetch artist");
    return await response.json();
  } catch (error) {
    console.error("Error fetching artist:", error);
    throw error;
  }
};

export const createArtist = async (userId, artistData) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/artists`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(artistData),
    });
    if (!response.ok) throw new Error("Failed to create artist");
    return await response.json();
  } catch (error) {
    console.error("Error creating artist:", error);
    throw error;
  }
};

export const updateArtist = async (userId, artistId, artistData) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/artists/${artistId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(artistData),
    });
    if (!response.ok) throw new Error("Failed to update artist");
    return await response.json();
  } catch (error) {
    console.error("Error updating artist:", error);
    throw error;
  }
};
export const deleteArtist = async (userId, artistId) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/artists/${artistId}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("Failed to delete artist");
    return await response.json();
  } catch (error) {
    console.error("Error deleting artist:", error);
    throw error;
  }
};

export const createBulkArtists = async (artistData) => {
  try {
    const response = await fetch(`${uri}/users/artists/bulk`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(artistData),
    });
    if (!response.ok) throw new Error("Failed to create artists");
    return await response.json();
  } catch (error) {
    console.error("Error creating artists:", error);
    throw error;
  }
};
